import React, { useState, useEffect } from "react";
import styled from "styled-components";

const BurgerMenu = styled.div`
  display: none;
  cursor: pointer;

  @media (max-width: 1024px) {
    display: block;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);

    span {
      display: block;
      width: 25px;
      height: 3px;
      background-color: white;
      margin: 5px 0;
      transition: all 0.3s ease;

      &:nth-child(1) {
        transform: ${(props) =>
          props.isOpen ? "rotate(45deg) translate(6px, 6px)" : "rotate(0)"};
      }

      &:nth-child(2) {
        opacity: ${(props) => (props.isOpen ? "0" : "1")};
      }

      &:nth-child(3) {
        transform: ${(props) =>
          props.isOpen ? "rotate(-45deg) translate(6px, -6px)" : "rotate(0)"};
      }
    }
  }
`;

export default function MenuIcon({
  isOpen,
    onMenuOpen
}) {
  const [isMenuOpen, setIsMenuOpen] = useState(isOpen);

  useEffect(() => {
    setIsMenuOpen(isOpen);
  }, [isOpen])

  return (
    <BurgerMenu isOpen={isMenuOpen} onClick={() => {
        setIsMenuOpen(!isMenuOpen);
        onMenuOpen(!isMenuOpen);
    }}>
      <span></span>
      <span></span>
      <span></span>
    </BurgerMenu>
  );
}
